module.exports = __webpack_public_path__ + "img/canada-diabetes-mellitus-male.ce14e563.png";